import { createSlice } from '@reduxjs/toolkit';

export const customCounsellingNineSlice = createSlice({
  name: 'customCounsellingNine',
  initialState: {
    allDataNine: null,
  },
  reducers: {
    setAllDataNine: (state, action) => {
      state.allDataNine = action.payload;
    },
  },
});

export const { setAllDataNine } = customCounsellingNineSlice.actions;
export default customCounsellingNineSlice.reducer;
